import React, { useEffect } from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import List from './List'

const ToDescribe: React.FC = ({}) => {
  const { path } = useRouteMatch()

  return (
    <>
      <Switch>
        <Route path={path + '/list'}>
          <List />
        </Route>
        <Redirect from={path} to={path + '/list'} />
      </Switch>
    </>
  )
}

export default ToDescribe
